import { FactoryProvider } from '@angular/core';
import { APPLICATION_CONFIGURATION_SERVICE, BaseConfigService } from '@lx/shared/app-config';
import { ENVIRONMENT } from '@lx/shared/tokens';
import { CoreEnvironment } from '@lx/shared/types';

export const getEnvironmentProvider = (env: CoreEnvironment): FactoryProvider => {
  return {
    provide: ENVIRONMENT,
    useFactory: (configService: BaseConfigService) => configService.getEnvironment(env),
    deps: [APPLICATION_CONFIGURATION_SERVICE],
  };
};
